<template>
  <div id="classDetailsDiv">
    <div class="classDetailsDiv_content">
      <div class="head_title class_head_title">
        <div class="head_title_font class_head_title_font">班级相册</div>
      </div>
      <div class="body_content class_body_content">

        <div class="writeMsg">
          <button type="button" class="btn btn-default zhaopian">上传照片</button>
        </div>
        <div>
          <div>
            <div>
              <img class="tupianyulan" src="../assets/img/right/classAlbum/yulantupian.png" />
            </div>
            <div class="tupianyulan1" >
              <br>A3ENAS.png
              <br>2019-01-15    ---ji
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {getContentSize} from './mainView';

  export default {
    name: "classAlbum",
    data() {
      return {
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
      });
    },
    methods: {

    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/classAlbum.css";
</style>



// WEBPACK FOOTER //
// src/components/classAlbum.vue